/* eslint-disable no-console */ function _check_private_redeclaration(obj, privateCollection) {
    if (privateCollection.has(obj)) {
        throw new TypeError("Cannot initialize the same private elements twice on an object");
    }
}
function _class_private_method_get(receiver, privateSet, fn) {
    if (!privateSet.has(receiver)) {
        throw new TypeError("attempted to get private field on non-instance");
    }
    return fn;
}
function _class_private_method_init(obj, privateSet) {
    _check_private_redeclaration(obj, privateSet);
    privateSet.add(obj);
}
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
import * as Sentry from '@sentry/react';
var _getSentryScope = /*#__PURE__*/ new WeakSet(), _captureEvent = /*#__PURE__*/ new WeakSet();
export class CerbosLogger {
    debug(event, context) {
        const ctx = context !== null && context !== void 0 ? context : this.ctx;
        ;
        void _class_private_method_get(this, _captureEvent, captureEvent).call(this, event, 'debug');
    }
    log(event, context) {
        const ctx = context !== null && context !== void 0 ? context : this.ctx;
        ;
        void _class_private_method_get(this, _captureEvent, captureEvent).call(this, event, 'info');
    }
    warn(event, context) {
        const ctx = context !== null && context !== void 0 ? context : this.ctx;
        console.warn("".concat(new Date().toLocaleString(), " \x1b[93mWARNING \x1b[93m[").concat(ctx, "] \x1b[93m").concat(event.message));
        void _class_private_method_get(this, _captureEvent, captureEvent).call(this, event, 'warning');
    }
    error(event, context) {
        const ctx = context !== null && context !== void 0 ? context : this.ctx;
        console.error("".concat(new Date().toLocaleString(), " \x1b[91mERROR \x1b[93m[").concat(ctx, "] \x1b[91m").concat(event.message));
        void _class_private_method_get(this, _captureEvent, captureEvent).call(this, event, 'error');
    }
    fatal(event, context) {
        const ctx = context !== null && context !== void 0 ? context : this.ctx;
        console.error("".concat(new Date().toLocaleString(), " \x1b[91mFATAL \x1b[93m[").concat(ctx, "] \x1b[91m").concat(event.message));
        void _class_private_method_get(this, _captureEvent, captureEvent).call(this, event, 'fatal');
    }
    constructor(ctx, useSentry = false){
        _class_private_method_init(this, _getSentryScope);
        _class_private_method_init(this, _captureEvent);
        _define_property(this, "ctx", void 0);
        _define_property(this, "useSentry", void 0);
        this.ctx = ctx;
        this.useSentry = useSentry;
    }
}
function getSentryScope() {
    return new Promise((resolve)=>{
        Sentry.withScope((scope)=>{
            scope.setTag('cerbos', 'true');
            resolve(scope);
        });
    });
}
async function captureEvent(event, level) {
    if (!this.useSentry) {
        return;
    }
    const scope = await _class_private_method_get(this, _getSentryScope, getSentryScope).call(this);
    scope.captureEvent({
        message: event.message,
        level,
        tags: {
            user: event.request.principal.id,
            action: event.request.action,
            kind: event.request.resource.kind,
            principal: event.request.principal.id,
            resource: event.request.resource.id,
            role: event.request.principal.roles[0],
            error: event.error ? "[".concat(event.error.name, "] ").concat(event.error.message) : undefined,
            stack: event.stack,
            controller: event.controller,
            handler: event.handler
        },
        extra: _object_spread({}, event.request.resource.attr)
    });
}
